<template>
  <v-row justify="center" class="ma-0">
    <v-col cols="12" class="pa-0">
      <v-toolbar height="60" dark color="primary">
        <v-btn fab x-small color="white" depressed @click="onClose()">
          <v-icon class="primary--text">close</v-icon>
        </v-btn>
        <v-toolbar-title class="white--text pl-2">イベント管理</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" class="elevation-0 mx-1" x-small fab @click="onFileExport()"><v-icon color="primary">mdi-upload</v-icon></v-btn>
        <input @change="onFileImport" type="file" name="file" accept="text/csv" ref="import">
        <v-btn color="white" class="elevation-0" x-small fab @click.stop="importDialog = true"><v-icon color="primary">mdi-download</v-icon></v-btn>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-card flat>
        <v-card-text class="pa-0">
          <v-row class="ma-0 pa-0" align="center" justify="center">
            <v-col cols="6" class="pa-0" align="center">
              <v-row class="ma-0 pa-0" align="center" justify="center">
                <v-col cols="12">
                  <v-toolbar flat height="40">
                    <v-toolbar-title class="text-left">雛形</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="primary" class="elevation-0" small rounded @click.stop="onChangeCategory()"><span class="font-weight-bold">{{ menuSort == 'category' ? '時間' : '種別' }}</span></v-btn>
                    <v-btn outlined color="error" class="elevation-0 mx-2" small rounded @click="removeDialog = true, removeAll = true, removeType = 'Template'">削除</v-btn>
                  </v-toolbar>
                </v-col>
                <v-col cols="12" class="py-0 not-select">
                  <v-sheet class='overflow-y-auto' :style="contentsHeight">
                    <template v-for="description in descriptions">
                      <v-row v-if="menuSort == 'category'" class="ma-0 pa-0" align="center" justify="center" :key="description.key">
                        <v-col cols="12" class="pa-0">
                          <v-toolbar flat :color="description.color" dark height="28">
                            <v-toolbar-title class="text-left">
                              <span>{{ description.name }}</span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon small @click.stop="onAdd(menuSort, description.key)"><v-icon>mdi-plus-circle</v-icon></v-btn>
                          </v-toolbar>
                        </v-col>
                        <v-col v-if="!prohibit" cols="12" class="pa-0">
                          <v-list dense>
                            <template v-for="item in myTemplatesByCatgory[description.key]">
                              <v-row class="ma-0 pa-0" style="cursor: pointer;" align="center" justify="center" @click.stop="onEditTemplate(item.item)" :key="item.item.key">
                                <v-col cols="11" class="pa-0">
                                  <v-row class="ma-0 pa-0" align="center" justify="center">
                                    <v-col cols="5" class="pa-0" align="start">
                                      <p :style="getEventTemplateWidth(item.item)" class="task">{{ item.item.period == 1 ? item.item.title : '⬇︎' + item.item.title }}</p>
                                    </v-col>
                                    <v-col cols="4" class="py-0" align="start" light>
                                      <p class="caption">{{ item.item.description }}</p>
                                    </v-col>
                                    <v-col cols="1" class="pa-0" align="end">
                                      <v-tooltip v-if="item.item.description" bottom color="transparent">
                                        <template v-slot:activator="{ on }">
                                          <v-icon v-on="on" color="primary" size="20">mdi-pencil-box</v-icon>
                                        </template>
                                        <v-card class="pa-0" width="200">
                                          <v-card-text class="pa-1 caption">
                                            <span>{{ item.item.description }}</span>
                                          </v-card-text>
                                        </v-card>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" class="pa-0" align="center">
                                      {{ $MONTHS1[item.item.month - 1] }}
                                      {{ $WEEK_TABLE[item.item.week - 1].name }}
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <v-col cols="1" class="pa-0" align="center">
                                  <v-btn outlined style="height:16px; border-radius:8px; margin:0;padding:0; display:block;" color="error" class="elevation-0 pa-0 ma-0" x-small rounded @click.stop="removeDialog = true, removeAll = false, removeType = 'Template', editTemplateItem = item.item">削除</v-btn>
                                </v-col>
                              </v-row>
                            </template>
                          </v-list>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-for="x in 12">
                      <v-row v-if="menuSort == 'time'" class="ma-0 pa-0" align="center" justify="center" :key="x + 'time'">
                        <v-col cols="12" class="pa-0">
                          <v-toolbar flat height="28" color="grey">
                            <v-toolbar-title class="text-left white--text subheading">
                              <span>{{ $MONTHS4_TABLE[x - 1].name }}</span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon small dark @click.stop="onAdd(menuSort, x)"><v-icon>mdi-plus-circle</v-icon></v-btn>
                          </v-toolbar>
                        </v-col>
                        <v-col v-if="!prohibit" cols="12" class="pa-0">
                          <v-list dense>
                            <template v-for="item in myTemplatesByTime[x - 1]">
                              <v-row class="ma-0 pa-0" style="cursor: pointer;" align="center" justify="center" @click.stop="onEditTemplate(item.item)" :key="item.item.key">
                                <v-col cols="11" class="pa-0">
                                  <v-row class="ma-0 pa-0" align="center" justify="center">
                                    <v-col cols="5" class="pa-0" align="start">
                                      <p :style="getEventTemplateWidth(item.item)" class="task">{{ item.item.period == 1 ? item.item.title : '⬇︎' + item.item.title }}</p>
                                    </v-col>
                                    <v-col cols="4" class="py-0" align="start">
                                      <p class="caption">{{ item.item.description }}</p>
                                    </v-col>
                                    <v-col cols="1" class="pa-0" align="end">
                                      <v-tooltip v-if="item.item.description" bottom color="transparent">
                                        <template v-slot:activator="{ on }">
                                          <v-icon v-on="on" color="primary" size="20">mdi-pencil-box</v-icon>
                                        </template>
                                        <v-card class="pa-0" width="200">
                                          <v-card-text class="pa-1 caption">
                                            <span>{{ item.item.description }}</span>
                                          </v-card-text>
                                        </v-card>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" class="pa-0" align="center">
                                      {{ $MONTHS1[item.item.month - 1] }}
                                      {{ $WEEK_TABLE[item.item.week - 1].name }}
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <v-col cols="1" class="pa-0" align="center">
                                  <v-btn outlined style="height:16px; border-radius:8px; margin:0;padding:0; display:block;" color="error" class="elevation-0 pa-0 ma-0" x-small rounded @click.stop="removeDialog = true, removeAll = false, removeType = 'Template', editTemplateItem = item.item">削除</v-btn>
                                </v-col>
                              </v-row>
                            </template>
                          </v-list>
                        </v-col>
                      </v-row>
                    </template>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6" class="pa-0" align="center">
              <v-row class="ma-0 pa-0" align="center" justify="center">
                <v-col cols="12">
                  <v-toolbar flat height="40">
                    <v-toolbar-title class="text-left subheading">
                      <span>{{ year + '年度' }}</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-select
                      prepend-icon="location_city"
                      :items='tempGroups'
                      label='教室'
                      v-model='tempGroup'
                      item-text="name"
                      item-value="key"
                      hideDetails
                    ></v-select>
                    <v-btn outlined color="error" class="elevation-0 mx-2" small rounded @click="removeDialog = true, removeAll = true, removeType = 'Event'">削除</v-btn>
                  </v-toolbar>
                </v-col>
                <v-col cols="12" class="py-0 not-select">
                   <v-sheet class='overflow-y-auto' :style="contentsHeight">
                    <template v-for="x in 12">
                      <v-row class="ma-0 pa-0" align="center" justify="center" :key="x + 'time'">
                        <v-col cols="12" class="pa-0">
                          <v-toolbar flat height="28" color="grey">
                            <v-toolbar-title class="text-left white--text subheading">
                              <span>{{ $MONTHS4_TABLE[x - 1].name }}</span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </v-col>
                        <v-col v-if="!prohibit" cols="12" class="pa-0">
                          <v-list dense>
                            <template v-for="item in myEvents[x - 1]">
                              <template v-if="item.type == 'data'">
                                <v-row v-if="checkTemplateDayAndZone(x, item.item)" class="ma-0 pa-0" style="cursor: pointer;" align="center" justify="center" @click.stop="onEditEvent(item.item)" :key="item.item.key">
                                  <v-col cols="11" class="pa-0">
                                    <v-row class="ma-0 pa-0" align="center" justify="center">
                                      <v-col cols="5" class="pa-0" align="start">
                                        <p :style="getEventWidth(item.item)" class="task">{{ item.item.period == 1 ? item.item.title : '⬇︎' + item.item.title }}</p>
                                      </v-col>
                                      <v-col cols="3" class="py-0" align="start">
                                        <p class="caption">{{ item.item.description }}</p>
                                      </v-col>
                                      <v-col cols="1" class="pa-0" align="end">
                                        <v-tooltip v-if="item.item.description" bottom color="transparent">
                                          <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" color="primary" size="20">mdi-pencil-box</v-icon>
                                          </template>
                                          <v-card class="pa-0" width="200">
                                            <v-card-text class="pa-1 caption">
                                              <span>{{ item.item.description }}</span>
                                            </v-card-text>
                                          </v-card>
                                        </v-tooltip>
                                      </v-col>
                                      <v-col cols="3" class="pa-0" align="center">
                                        <span>{{ MMDD(item.item.startDate) }}</span>
                                        <template v-if="item.item.type != 'holiday' && item.item.startDate != item.item.endDate">
                                          <span> - </span>
                                          <span>{{ MMDD(item.item.endDate) }}</span>
                                        </template>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="1" class="pa-0" align="center">
                                    <v-btn v-if="item.type == 'data'" outlined style="height:16px; border-radius:8px; margin:0;padding:0; display:block;" color="error" class="elevation-0 pa-0 ma-0" x-small rounded @click.stop="removeDialog = true, removeAll = false, removeType = 'Event', editTemplateItem = item.item">削除</v-btn>
                                  </v-col>
                                </v-row>
                              </template>
                            </template>
                          </v-list>
                        </v-col>
                      </v-row>
                    </template>
                   </v-sheet>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

    <div class="text-center">
      <v-layout row justify-center>
        <v-dialog
          v-model='editDialog'
          persistent
          :max-width="'400'">
          <app-event-edit
            v-if="editDialog"
            @dismissed="onDismissed"
            :item="editTemplateItem"
            :dialog='editDialog'
            :event="event"
          >
          </app-event-edit>
        </v-dialog>
      </v-layout>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        :title="removeType == 'Template' ? '雛形' : 'イベント'"
        :message="removeAll ? '全てのデータを削除します。よろしいですか?' : '削除します。よろしいですか?'"
        :dialog='removeDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        v-if='importDialog'
        @dismissed="onFileSelect"
        :title="'インポート'"
        :message="'現在のテンプレートおよびイベントデータは削除されます。よろしいですか？'"
        :dialog='importDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>
  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import * as Papa from 'papaparse'
import * as async from 'async'
import GoogleMapsDialog from '../../components/google/GoogleMapsDialog.vue'
import EventEditDialog from './EventEditDialog.vue'
import Moment from 'moment-timezone'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)
Vue.component('app-google-maps', GoogleMapsDialog)
Vue.component('app-event-edit', EventEditDialog)

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      scheduleEvents: 'scheduleEvents/events',
      templateEvents: 'templateEvents/templates',
      windowSize: 'shared/windowSize'
    }),
    form () {
      return {
        category: this.templateItem.category,
        title: this.templateItem.title,
        startDate: this.myItem.startDate,
        endDate: this.myItem.endDate
      }
    },
    myTemplatesByCatgory () {
      var temp = {}
      var index = 1
      for (var c in this.descriptions) {
        temp[this.descriptions[c].key] = []
        // temp[this.descriptions[c].key].push({ key: index, type: 'header', item: this.descriptions[c] })
        // index += 1
      }
      for (var i in this.templateEvents) {
        temp[this.templateEvents[i].category].push({ key: index, type: 'data', item: this.templateEvents[i] })
        index += 1
      }
      for (i in temp) {
        temp[i].sort(function (a, b) {
          var am = a.item.month < 4 ? a.item.month + 8 : a.item.month - 4
          var bm = b.item.month < 4 ? b.item.month + 8 : b.item.month - 4
          if (am > bm) return 1
          if (am < bm) return -1
          if (a.item.week > b.item.week) return 1
          if (a.item.week < b.item.week) return -1
          return 0
        })
      }
      return temp
    },
    myTemplatesByTime () {
      var temp = {}
      var index = 1
      for (var mm = 0; mm < 12; mm++) {
        var m = mm < 3 ? mm + 9 : mm - 3
        temp[m] = []
        // temp[m].push({ key: index, type: 'header', item: mm })
        // index += 1
      }
      for (var i in this.templateEvents) {
        m = this.templateEvents[i].month < 4 ? this.templateEvents[i].month + 8 : this.templateEvents[i].month - 4
        temp[m].push({ key: index, type: 'data', item: this.templateEvents[i] })
        index += 1
      }
      for (i in temp) {
        temp[i].sort(function (a, b) {
          var am = a.item.month < 4 ? a.item.month + 8 : a.item.month - 4
          var bm = b.item.month < 4 ? b.item.month + 8 : b.item.month - 4
          if (am > bm) return 1
          if (am < bm) return -1
          if (a.item.week > b.item.week) return 1
          if (a.item.week < b.item.week) return -1
          return 0
        })
      }
      return temp
    },
    myEvents () {
      var temp = {}
      var index = 1
      for (var mm = 0; mm < 12; mm++) {
        var m = mm < 3 ? mm + 9 : mm - 3
        temp[m] = []
        // temp[m].push({ key: index, type: 'header', item: mm })
        // index += 1
      }
      for (var x in this.events) {
        for (var y in this.events[x]) {
          for (var z in this.events[x][y]) {
            m = this.events[x][y][z].start.mm < 4 ? this.events[x][y][z].start.mm + 8 : this.events[x][y][z].start.mm - 4
            if (this.tempGroup === '*') {
              temp[m].push({ key: index, type: 'data', item: this.events[x][y][z] })
              index += 1
            } else if (this.events[x][y][z].type === 'event' && this.events[x][y][z].groups[this.tempGroup]) {
              temp[m].push({ key: index, type: 'data', item: this.events[x][y][z] })
              index += 1
            }
          }
        }
      }
      return temp
    },
    mySchool () {
      var keys = Object.keys(this.data.schools)
      for (var i in keys) {
        if (this.data.schools[keys[i]]) {
          var index = this.schools.findIndex(s => s.key === keys[i])
          if (index !== -1) {
            return JSON.parse(JSON.stringify(this.schools[index]))
          }
        }
      }
      return null
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 64) + 'px;'
    }
  },
  props: [ 'item', 'dialog', 'group', 'tempGroups', 'year', 'events', 'eventTemplates' ],
  data () {
    return {
      prohibit: true,
      importDialog: false,
      startDate: false,
      endDate: false,
      startTime: false,
      endTime: false,
      myItem: null,
      templateItem: null,
      editTemplateItem: null,
      editDialog: false,
      eventTemplate: null,
      event: null,
      removeDialog: false,
      removeType: null,
      removeAll: false,
      loading: false,
      formHasErrors: false,
      type: null,
      charges: [],
      comment: null,
      tempKeys: {},
      tempGroup: null,
      hide: [ false, false, false, false, false, false, false, false, false, false, false, false ],
      rules: {
        required: value => !!value || '必須',
        diffDate: value => {
          var ds = new Date(this.myItem.startDate)
          var de = new Date(this.myItem.endDate)
          return ds.getTime() <= de.getTime() || '日付が無効です'
        }
      },
      descriptions: [],
      menuItems: [
        { title: '種別順', value: 'category' },
        { title: '時間順', value: 'time' }
      ],
      menuSort: 'category'
    }
  },
  created () {
    this.tempGroup = JSON.parse(JSON.stringify(this.group))
    Vue.prototype.$DAY_OF_WEEK = [ '01', '07', '14', '21' ]
    this.templateItem = JSON.parse(JSON.stringify(this.$store.getters['templateEvents/initial']))
    var index = this.templateEvents.findIndex(event => event.key === this.item.template)
    if (index !== -1) {
      this.templateItem = JSON.parse(JSON.stringify(this.templateEvents[index]))
    }
    this.myItem = JSON.parse(JSON.stringify(this.item))
    this.descriptions = JSON.parse(JSON.stringify(this.$DESCRIPTIONS_ITEMS))
    this.myItem.charge = this.user.uid
  },
  mounted () {
    this.wait()
  },
  methods: {
    async wait () {
      this.prohibit = true
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      await pause(800).then(() => {
        this.prohibit = false
      })
    },
    checkTemplateDayAndZone (x, item) {
      return parseInt(this.$MONTH[x - 1]) === item.start.mm
    },
    getEventWidth (item) {
      // var value = 0
      var s = ''
      // value = this.windowSize.x * 0.09 * (this.edit ? 0.75 : 1)
      // s = 'width: ' + value.toString() + 'px; height: 16px;'
      s += ' font-size:12px; color: white;'
      s += ' background-color: ' + this.getDescriptionColor(item) + ';'
      return s
    },
    getEventTemplateWidth (item) {
      // var value = 0
      var s = ''
      // value = this.windowSize.x * 0.09 * (this.edit ? 0.75 : 1)
      // s = 'width: ' + value.toString() + 'px; height: 16px;'
      s += ' font-size:12px; color: ' + this.getDescriptionColor(item) + ';'
      s += ' background-color: #FFFFFF; border: 1px solid ' + this.getDescriptionColor(item) + ';'
      return s
    },
    // checkHide (item) {
    //   var index = this.descriptions.findIndex(d => d.key === item.category)
    //   return index !== -1
    // },
    onChangeCategory () {
      this.menuSort = this.menuSort === 'category' ? 'time' : 'category'
    },
    onMenu (item) {
      this.menuSort = item.value
    },
    onAdd (sort, item) {
      this.editTemplateItem = JSON.parse(JSON.stringify(this.$store.getters['templateEvents/initial']))
      if (sort === 'category') {
        this.editTemplateItem.category = item
      } else {
        this.editTemplateItem.month = parseInt(this.$MONTH[item - 1])
      }
      this.event = 'template'
      this.editDialog = true
    },
    onEditTemplate (item) {
      this.editTemplateItem = JSON.parse(JSON.stringify(item))
      this.event = 'template'
      this.editDialog = true
    },
    onEditEvent (item) {
      if (item.type !== 'holiday') {
        this.editTemplateItem = JSON.parse(JSON.stringify(item))
        this.event = 'event'
        this.editDialog = true
      }
    },
    onRemove () {
      var vm = this
      this.removeDialog = false
      this.loading = true
      var path = this.removeType === 'Template' ? 'templateEvents/delete' : 'scheduleEvents/delete'
      this.$nextTick(function () {
        if (this.removeAll) {
          this.prohibit = true
          if (this.removeType === 'Template') {
            this.removeAllSub(JSON.parse(JSON.stringify(vm.scheduleEvents)), 'scheduleEvents/delete', false).then(() => {
              this.removeAllSub(JSON.parse(JSON.stringify(vm.templateEvents)), 'templateEvents/delete', false).then(() => {
                vm.prohibit = false
                vm.loading = false
              })
            })
          } else {
            this.removeAllSub(JSON.parse(JSON.stringify(vm.scheduleEvents)), 'scheduleEvents/delete', true).then(() => {
              vm.prohibit = false
              vm.loading = false
            })
          }
        } else {
          var payload = vm.editTemplateItem.key
          vm.$store.dispatch(path, payload).then(() => {
            if (this.removeType === 'Template') {
              var temp = vm.scheduleEvents.filter(function (item, index) {
                return item.template === vm.editTemplateItem.key
              })
              this.removeAllSub(JSON.parse(JSON.stringify(temp)), 'scheduleEvents/delete', false).then(() => {
                vm.loading = false
              })
            } else {
              vm.loading = false
            }
          })
        }
      })
    },
    onFileSelect: function (value) {
      this.importDialog = false
      if (value) {
        this.$nextTick(function () {
          this.$refs.import.click()
        })
      }
    },
    checkGroup (item) {
      if (this.tempGroup === '*') {
        return true
      }
      if (typeof item.groups[this.tempGroup] === 'undefined') {
        return false
      }
      return item.groups[this.tempGroup]
    },
    removeAllSub (items, path, check) {
      var vm = this
      return new Promise((resolve) => {
        async.eachSeries(items, function (item, cb) {
          var payload = item.key
          if (item.schools[vm.mySchool.key]) {
            if (!check || (check && vm.checkGroup(item))) {
              vm.$store.dispatch(path, payload).then(() => {
                cb()
              })
            } else {
              cb()
            }
          }
        }, function (error) {
          if (error) {
            console.log(error)
          }
          resolve()
        })
      })
    },
    removeAllDate () {
      var vm = this
      return new Promise((resolve) => {
        this.removeAllSub(JSON.parse(JSON.stringify(vm.scheduleEvents)), 'scheduleEvents/delete', true).then(() => {
          this.removeAllSub(JSON.parse(JSON.stringify(vm.templateEvents)), 'templateEvents/delete', true).then(() => {
            resolve()
          })
        })
      })
    },
    onFileImport (e) {
      var vm = this
      this.tempKeys = {}
      vm.file = null
      e.preventDefault()
      let files = e.target.files
      if (files.length === 0) {
        return
      }
      this.file = files[0]
      var reader = new FileReader()
      reader.onerror = function () {
        console.log('error')
      }
      this.prohibit = true
      this.loading = true
      this.$nextTick(function () {
        const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
        pause(1).then(() => {
          this.removeAllDate().then(() => {
            reader.onload = function () {
              Papa.parse(files[0], {
                encoding: 'UTF8',
                header: true,
                complete: function (results) {
                  async.eachSeries(results.data, function (item, cb) {
                    if (item.type === 'template') {
                      vm.storeEvent(item).then(() => {
                        cb()
                      })
                    } else {
                      cb()
                    }
                  }, function (error) {
                    if (error) {
                      console.log(error)
                    }
                    async.eachSeries(results.data, function (item, cb) {
                      if (item.type === 'event') {
                        vm.storeEvent(item).then(() => {
                          cb()
                        })
                      } else {
                        cb()
                      }
                    }, function (error) {
                      if (error) {
                        console.log(error)
                      }
                      vm.prohibit = false
                      vm.loading = false
                    })
                  })
                },
                error () {
                  vm.prohibit = false
                  vm.loading = false
                }
              })
            }
            reader.readAsArrayBuffer(this.file)
          })
        })
      })
    },
    storeEvent (item) {
      return new Promise((resolve) => {
        var vm = this
        var payload = null
        var path = 'templateEvents/write'
        if (item.type === 'event') {
          path = 'scheduleEvents/write'
          payload = JSON.parse(JSON.stringify(this.$store.getters['scheduleEvents/initial']))
          var start = moment(item.startDate)
          moment.tz.setDefault('Asia/Tokyo')
          payload.startDate = item.startDate
          payload.start = {
            date: start.format('YYYY-MM-DD'),
            yyyy: parseInt(start.format('YYYY')),
            mm: parseInt(start.format('MM')),
            dd: parseInt(start.format('DD'))
          }
          payload.startTime = item.startTime === '' ? null : item.startTime
          var end = moment(item.endDate)
          payload.endDate = item.endDate
          payload.end = {
            date: end.format('YYYY-MM-DD'),
            yyyy: parseInt(end.format('YYYY')),
            mm: parseInt(end.format('MM')),
            dd: parseInt(end.format('DD'))
          }
          payload.endTime = item.endTime === '' ? null : item.endTime
          payload.duration = parseInt(item.duration)
          if (typeof vm.tempKeys[item.template] === 'undefined') {
            resolve()
            return
          }
          payload.template = vm.tempKeys[item.template]
          var groups = {}
          for (var i in this.group) {
            groups[this.group[i]] = true
          }
          payload.groups = groups
        } else {
          payload = JSON.parse(JSON.stringify(this.$store.getters['templateEvents/initial']))
          payload.category = parseInt(item.category)
          payload.title = item.title
          payload.description = item.description
          payload.month = parseInt(item.month)
          payload.week = parseInt(item.week)
          payload.period = parseInt(item.period)
        }
        payload.schools[this.mySchool.key] = true
        payload.createdAt = payload.updatedAt = parseInt(new Date().getTime())
        vm.$store.dispatch(path, JSON.parse(JSON.stringify(payload))).then((resp) => {
          if (typeof resp !== 'undefined' && resp.type === 'template') {
            vm.tempKeys[item.key] = resp.key
          }
          resolve()
        })
      })
    },
    onFileExport () {
      var temp = []
      var name = 'export-event'

      const config = {
        delimiter: ',',
        header: true,
        newline: '\n'
      }

      for (var i in this.eventTemplates) {
        var v = JSON.parse(JSON.stringify(this.eventTemplates[i]))
        temp.push({
          type: 'template',
          key: v.key,
          category: v.category,
          title: v.title,
          description: v.description,
          month: v.month,
          week: v.week,
          period: v.period,
          template: null,
          startDate: null,
          startTime: null,
          endDate: null,
          endTime: null,
          duration: null
        })
      }
      for (i in this.scheduleEvents) {
        v = JSON.parse(JSON.stringify(this.scheduleEvents[i]))
        temp.push({
          type: 'event',
          template: v.template,
          startDate: v.startDate,
          startTime: v.startTime,
          endDate: v.endDate,
          endTime: v.endTime,
          duration: v.duration
        })
      }
      const delimiterString = Papa.unparse(temp, config)
      const blobUrl = new Blob([delimiterString], { type: 'text/csv' })
      const blob = blobUrl
      const aTag = document.createElement('a')

      aTag.download = this.year + '-' + name + '.csv'

      if (window.navigator.msSaveBlob) {
        // for IE
        window.navigator.msSaveBlob(blob, aTag.download)
      } else if (window.URL && window.URL.createObjectURL) {
        // for Firefox
        aTag.href = window.URL.createObjectURL(blob)
        document.body.appendChild(aTag)
        aTag.click()
        document.body.removeChild(aTag)
      } else if (window.webkitURL && window.webkitURL.createObject) {
        // for Chrome
        aTag.href = (window.URL || window.webkitURL).createObjectURL(blob)
        aTag.click()
      } else {
        // for Safari
        window.open(
          `data:type/csv;base64,${window.Base64.encode(this.state.content)}`,
          '_blank'
        )
      }
    },
    onClose () {
      this.$emit('dismissed')
    },
    onDismissed: function (value) {
      if (this.removeDialog) {
        this.removeDialog = false
        if (value) {
          this.onRemove()
        }
        return
      }
      if (value) {
        this.myItem.location = value.name
      }
      this.editDialog = false
    }
  }
}
</script>

<style scoped>
.scroller {
  height: 100%;
}

p.task {
  white-space: nowrap;
  overflow: hidden;
  border-radius: 0px;
  font-size: 12px !important;
  line-height: 16px !important;
}

p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 8px;
  padding-left: 6px;
  margin: 2px;
  user-select: none;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}

span {
  user-select: none;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}

input[type="file"] {
  display: none;
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 4px;
}
::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(0,0,0,.5);
    box-shadow: 0 0 1px rgba(255,255,255,.3);
}

</style>
